import { ComponentIds } from '@inter-ikea-core/core';
import { PlannerEcsMultiSystem } from './System';
import CollisionComponent from '../components/CollisionComponent';
import { AlbedoColor } from '../SceneApi';
import EventComponent from '../components/EventComponent';
export class CollisionSystem extends PlannerEcsMultiSystem {
    constructor(coreApi, productTypesToRemove) {
        super(coreApi, 'CollisionSystem', [
            CollisionComponent.id,
            EventComponent.id,
            ComponentIds.IS_LOADING_SNAPSHOT_COMPONENT_ID
        ]);
        this.productTypesToRemove = undefined;
        this.productTypesToRemove = productTypesToRemove;
    }
    onAdd(entity, newComponent) {
        if (newComponent.typeId === CollisionComponent.id) {
            this.handleCollisionAdded(entity);
        }
    }
    onUpdate(entity, oldComponent, newComponent) {
        if (newComponent.typeId === EventComponent.id &&
            newComponent.event === 'history') {
            const invalidPlacements = this.validateFramePlacements();
            this.handleInvalidPlacements(invalidPlacements);
        }
    }
    onRemove(entity, oldComponent) {
        if (oldComponent.typeId === CollisionComponent.id) {
            this.handleCollisionRemoved(entity);
        }
        else if (oldComponent.typeId === ComponentIds.IS_LOADING_SNAPSHOT_COMPONENT_ID) {
            // When performing an undo / redo action the new state can contain objects
            // that was previously painted red but the entity no longer has a collision
            // component. So to fix this we remove red color from all objects that do not
            // still have a CollisionComponent
            const allEntitiesWithoutCollision = this.coreApi.entities
                .getAll()
                .filter(e => !e.hasComponent(CollisionComponent.id));
            allEntitiesWithoutCollision.forEach(e => {
                const objectId = this.coreApi.entities.getObjectId(e);
                if (objectId) {
                    this.coreApi.scene?.setObjectBaseColor(AlbedoColor.NONE, objectId);
                }
            });
        }
    }
    handleCollisionAdded(entity) {
        // In some ranges where we have system that acts outside the history we sometimes get weird collisions
        // We now initiate this system with an optional parameter to include productTypes that we know we want to remove if we get a collision
        const productType = this.coreApi.entities.getProductType(entity);
        if (this.productTypesToRemove &&
            productType &&
            this.productTypesToRemove.includes(productType)) {
            this.coreApi.entities.delete(entity);
        }
        else {
            const objectId = this.coreApi.entities.getObjectId(entity);
            if (!objectId)
                return;
            this.coreApi.scene?.setObjectBaseColor(AlbedoColor.RED, objectId);
        }
    }
    handleCollisionRemoved(entity) {
        const objectId = this.coreApi.entities.getObjectId(entity);
        if (objectId) {
            this.coreApi.scene?.setObjectBaseColor(AlbedoColor.NONE, objectId);
        }
    }
    validateFramePlacements() {
        const frames = this.coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);
        const validations = this.coreApi.getServices().validations;
        const collidingEntities = [];
        frames.forEach(frame => {
            const validationResult = validations.validateCurrentState(frame);
            validationResult.forEach((result) => {
                if (result.collisions) {
                    result.collisions.forEach((collision) => collidingEntities.push(collision.other));
                }
            });
        });
        return collidingEntities;
    }
    handleInvalidPlacements(entities) {
        this.coreApi.entities.getByComponent(CollisionComponent.id).forEach(frame => {
            frame.removeComponent(CollisionComponent.id);
        });
        entities.forEach(entity => entity.addComponent(new CollisionComponent()));
    }
}
//# sourceMappingURL=CollisionSystem.js.map